import CurrencyFormatter from "currency-formatter";

export default class FinancingHelper {
  static bracketFormatter(value) {
    return value < 0
      ? `(${CurrencyFormatter.format(-value, { code: "USD" })})`
      : CurrencyFormatter.format(value, { code: "USD" })
  }

  static bracketIntegerFormatter(value) {
    return value < 0
      ? `(${CurrencyFormatter.format(-value, { code: "USD", precision: 0 })})`
      : CurrencyFormatter.format(value, { code: "USD", precision: 0 })
  }

  static calculatePMT({
    interestRate,
    numberOfPeriods,
    presentValue,
    futureValue,
    paymentType
  }) {
    // Convert the interest rate from percentage to decimal
    interestRate = interestRate / 100;

    // Calculate the periodic interest rate
    const periodicRate = interestRate / 12;

    // Calculate the number of periods
    const numPeriods = numberOfPeriods;

    // Calculate the present value and future value adjustments
    const _presentValue = (futureValue || 0) + presentValue;
    const _futureValue = (futureValue || 0);

    // Calculate the payment
    let payment = (_presentValue * periodicRate) / (1 - Math.pow(1 + periodicRate, -numPeriods));

    // Adjust the payment based on the payment type
    if (paymentType && paymentType === 1) {
      payment /= (1 + periodicRate);
    }

    // Round the payment to two decimal places
    payment = Math.round(payment * 100) / 100;

    return -payment;
  }

  static  calculateCumulativeInterestPayment({
   interestRate,
   numberOfPeriods,
   presentValue,
   startPeriod,
   endPeriod,
   paymentType
  }) {
    // Convert the interest rate from percentage to decimal
    interestRate = interestRate / 100;

    // Calculate the periodic interest rate
    const periodicRate = interestRate / 12;

    // Calculate the number of periods
    const numPeriods = numberOfPeriods;

    // Calculate the cumulative interest payment
    let cumulativeInterestPayment = 0;

    for (let i = startPeriod; i <= endPeriod; i++) {
      // Calculate the interest payment for the current period
      let interestPayment = -presentValue * periodicRate;

      // Adjust the interest payment based on the payment type
      if (paymentType && paymentType === 1) {
        interestPayment -= (presentValue - cumulativeInterestPayment) * periodicRate;
      }

      // Add the interest payment to the cumulative interest payment
      cumulativeInterestPayment += interestPayment;

      // Calculate the remaining principal
      presentValue += interestPayment;

      // Subtract the periodic payment from the remaining principal
      if (i < endPeriod) {
        presentValue -= this.calculatePMT({
          interestRate,
          numberOfPeriods: numPeriods - i,
          presentValue,
          paymentType
        });
      }
    }

    // Round the cumulative interest payment to two decimal places
    cumulativeInterestPayment = Math.round(cumulativeInterestPayment * 100) / 100;

    return cumulativeInterestPayment;
  }

  static XIRR(array) {
    let series = [...array.map((obj) => (obj.value))];
    let rate = 0;
    let step = 0.1;
    let invalid = true;

    //return NaN when all element is possitive, to save time
    series.map((val) => {if(val < -0.01) invalid = false;});
    if(invalid) return NaN;

    if(series.reduce((acc, val) => acc + val, 0) < 0) {
      //when XIRR < 0
      step = -0.1;
      series = series.map((val) => (-val));  //let's calculate XIRR as possitive
    }
    for(rate = 0; Math.abs(step) > 0.0000009; rate += step) {
      if(series.reduce((acc, val, index) => acc + val / Math.pow((1 + rate), index + 1), 0) < 0) {
        rate -= step;
        step /= 10;
      }
      if(rate >= 10000) return NaN;   //prevent endless loop
    }

    return rate;
  }

  static MIRR(array, frate, rrate) {
    let series = [...array.map((obj) => (obj.value))];
    let n = series.length;
    let positiveNPV = 0;
    let negativeNPV = 0;
    series.map((val, index) => {
      if(val > 0) positiveNPV += val / Math.pow((1 + rrate), index + 1);
      else negativeNPV += val / Math.pow((1 + frate), index + 1);
    })

    return Math.pow((-positiveNPV * Math.pow((1 + rrate), n) / (negativeNPV * (1 + frate))), 1 / (n - 1)) - 1;
  }

  static EM(array) {
    const series = [...array.map((obj) => (obj.value))];
    const positive = series.reduce((acc, val) => (acc + (val > 0 ? val : 0)), 0);
    const negative = series.reduce((acc, val) => (acc + (val < 0 ? val : 0)), 0);

    return -positive / negative;
  }
}